import { render, staticRenderFns } from "./Staff.vue?vue&type=template&id=3e2ccb85&"
import script from "./Staff.vue?vue&type=script&lang=js&"
export * from "./Staff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/miryamfv/Proyectos/valet/dz0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e2ccb85')) {
      api.createRecord('3e2ccb85', component.options)
    } else {
      api.reload('3e2ccb85', component.options)
    }
    module.hot.accept("./Staff.vue?vue&type=template&id=3e2ccb85&", function () {
      api.rerender('3e2ccb85', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Staff.vue"
export default component.exports